<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/jala-harvest";

export default {
  extends: ModelCreateModal,
  props: {
    modalTitle: {default() { return this.lodash.startCase(this.$t('jala_harvests.singular')) }},
    resourceRoute: {default: 'jala_harvests'},
    modelVariable: {default: 'harvest'},
    form: {default() { return FormsModel; }}
  },
  methods: {
    store(value) {
      return this.$axios.post('/jala/harvests', value);
    }
  },
}
</script>
